import { FORMAT_XLSX, FORMAT_CSV, FORMAT_PDF, ExportFormat } from "../../../../common/constants/export-constants";

export const FORMAT_KEYS = {
  [FORMAT_XLSX]: "xlsx",
  [FORMAT_CSV]: "csv",
  [FORMAT_PDF]: "pdf",
} as const;

export const getTranslatedFormats = (
  t: any,
  supportedFormats: ExportFormat[],
  defaultContent: Record<string, any>,
  separator = "/",
): string => {
  const formatNames = supportedFormats.map((format) =>
    t(`formats.${FORMAT_KEYS[format]}`, defaultContent.formats[FORMAT_KEYS[format]]),
  );
  return formatNames.join(separator);
};
